export const localStorageId = "show-navigation-menu";
